(function(window, document, $){
	"use strict";

	var Message = function( element ){
		this.$element = $(element);
		this.$element.find('[data-role="close"]').on('click', this.close.bind(this));

		return this;
	};
	Message.prototype = {
		close: function( event ){
			event.preventDefault();
			this.$element.slideUp({
				duration: 250,
				progress: function( promise, progress, remainingTime ){
					var percent = 1 - progress;
					$(this).css('opacity', percent);
				},
				complete: function(){
					$(this).remove();
				}
			});
		}
	};


	$.fn.message = function(){
		if( this.data('message') ){ return this.data('message'); }
		return this.each(function(i, el){
			$(el).data('message', (new Message(el)));
		});
	};

	// self initialization
	$(document).ready(function(){
		$('[data-module="message"]').message();
	});

	//TABS
	var $window = $(window),
			$document = $(document),
			$body = $('body');

	var App = function(){
			this.path = $('body').attr("data-path");
			this.ajaxURL = '/wp-admin/admin-ajax.php';


			var app = this;
	};

	App.prototype = {
			onReady : function(){
					this.setGlobals();
					this.autoHandleEvents( $('[data-func]') );
					this.initValidFile();


			},
			setGlobals : function(){
					$body = $('body');
			},
			autoHandleEvents : function( $elements ){
					if( !$elements || !$elements.length ){ return false; }

					var self = this;

					$elements.each(function(i,el){
							var func = el.getAttribute('data-func') || false,
									evts = el.getAttribute('data-events') || 'click.customStuff';

							if( func && typeof( self[func] ) === 'function' ){
									$(el)
											.off(evts)
											.on(evts, $.proxy(self[func], self))
											.attr('data-delegated', 'true');
							}
					});
			},
			showTarget : function( event ){
					event.preventDefault();
					$target = $('#' + event.currentTarget.getAttribute('data-target')).show();
			},
			showTab : function( event ){
					event.preventDefault();
					var $item = $(event.currentTarget);

					$('[data-tabname="'+ $item.data('target') +'"]').addClass('active').siblings().removeClass('active');
					$item.addClass('active').siblings().removeClass('active');
			},

			initValidFile: function(){
				$('[data-role="validfile"]').change(function(e){
					var $input = $(this),
						filename = $(this).val(),
						$father = $input.parents('.form-control').find('.form-control--file'),
						$mother = $input.parents('.form-control'),
						maxsize = $input.data('max-size'),
						filesize = $input.get(0).files[0].size,
						$okmessage = $mother.find('.form-control__text').text(),
						$errormessage = $mother.data('error-message');

					e.preventDefault();
					console.log('filesize: ' + filesize);
					console.log('okmessage: ' + $okmessage);
					//define el limite de tamaño
					if(maxsize){
						maxsize = maxsize;
						console.log('limit defined:' + maxsize);
					}else{
						maxsize = 100000 //100mb
						console.log('limit undefined:' + maxsize);
					}

					if(filesize>maxsize){
						console.log('too heavy');
						$mother.find('.form-control__text').html($errormessage);
						return false;
					}else{
						console.log('just right');
						$mother.find('.form-control__text').hide();
						if (filename.substring(3,11) == 'fakepath') {
							filename = filename.substring(12);
						}
						if(!filename){
							filename = $father.find('.content__btn--file__desc').text();
						}
						$father.find('.content__btn--file__desc').html(filename);
						return true;
					}
				});
			}
	};

	var app = new App();
	$document.ready(function(){ app.onReady && app.onReady(); });

}(window, document, jQuery));
